import { render, staticRenderFns } from "./CustomIndicator.vue?vue&type=template&id=6dfb0ffa&scoped=true"
import script from "./CustomIndicator.vue?vue&type=script&lang=js"
export * from "./CustomIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb0ffa",
  null
  
)

export default component.exports